import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBasePage, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { Role, RoleSave } from "../role";

export class RequestRole extends RequestBasePageId {

  licenseId?: string | null;
  userFilterId?: string | null;
  active?: boolean | null;
  roleTypes?: string[] | null;

}

export class RequestRoleSet extends RequestBaseSet<RoleSave>
{
}

export class ResponseRole extends ResponseBasePage<Role> {

}


export class ResponseRoleSet extends ResponseBaseSet<Role>{

}
